import { createColumnHelper } from "@tanstack/react-table";
import actionIcon from "assets/svg/action.svg";
import deleteIcon from "assets/svg/delete.svg";
import plusIcon from "assets/svg/plus-icon.svg";
import DataTable from "components/datatable/datatable";
import Loader from "components/loader";
import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { deleteForm, getAllForms } from "../../../axios/api";
import Modal from "react-modal";
import "./style.css";

const Forms = () => {
  const navigate = useNavigate();
  const [searchField, setSearchField] = useState("");

  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    filter: {},
  });
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState<any>();
  const [totalCount, setTotalCount] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState<string | null>(null);
  const columnHelper = createColumnHelper<any>();

  const columns: any = [
    columnHelper.accessor("title", {
      id: "title",
      header: () => (
        <p className="text-base font-normal text-[#424242] dark:text-white">
          Form Title
        </p>
      ),
      cell: (info) => (
        <div className="flex items-center">
          <p className="ml-3 flex items-center  text-sm font-bold text-navy-700 dark:text-white">
            {info.getValue()}
          </p>
        </div>
      ),
    }),
    columnHelper.accessor("form_url", {
      id: "form_url",
      header: () => (
        <p className="text-base font-normal text-[#424242] dark:text-white">
          Form URL
        </p>
      ),
      cell: (info) => (
        <div className="flex items-center">
          <p className="ml-3 flex items-center  text-sm font-bold text-blue-600 underline dark:text-white">
            <a href={info.getValue()} target="_blank" rel="noreferrer">
              {info.getValue().slice(0, 20)}
            </a>
          </p>
        </div>
      ),
    }),
    columnHelper.accessor("id", {
      id: "id",
      header: () => (
        <p className="px-[3rem] text-base font-normal text-[#424242] dark:text-white">
          Action
        </p>
      ),
      cell: (info) => (
        <div className="flex gap-2">
          <button
            type="button"
            onClick={() =>
              navigate(`/admin/forms/edit`, { state: info.getValue() })
            }
            className="text-black me-2 inline-flex items-center rounded-lg border-4 px-3 py-2.5 text-center text-sm font-medium hover:bg-[#0098DA] hover:text-white focus:outline-none focus:ring-4 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          >
            <img
              src={actionIcon}
              alt="action-icon"
              className="w-4.1 me-2 h-5"
            />
            Edit
          </button>
          <button
            onClick={() => openModal(info.row.original.id)}
            type="button"
            className="text-black me-2 inline-flex items-center rounded-lg border-4 px-3 py-2.5 text-center text-sm font-medium hover:bg-[#0098DA] hover:text-white focus:outline-none focus:ring-4 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          >
            <img
              src={deleteIcon}
              alt="delete-icon"
              className="w-4.1 me-2 h-5"
            />
            Delete
          </button>
        </div>
      ),
    }),
  ];

  useEffect(() => {
    const fetchForms = async () => {
      try {
        setLoading(true);
        const formDataResp = await getAllForms(filter.page, filter.limit);
        setFormData(formDataResp?.data?.data?.forms);
        setTotalCount(formDataResp?.data?.data?.totalResults);
        if (!formDataResp?.data?.success) {
          toast.error("Error in Fetching Forms");
          console.log("formDataResp", formDataResp);
        }
      } catch (error) {
        console.log("error", error);
        toast.error("Error in Fetching Forms");
      } finally {
        setLoading(false);
      }
    };
    fetchForms();
  }, [filter]);

  const onPageChange = ({ selected }: any) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      page: selected + 1,
    }));
  };

  const openModal = (id: string) => {
    setDeleteId(id);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setDeleteId(null);
  };

  const handleDelete = async () => {
    if (deleteId) {
      try {
        await deleteForm(deleteId);
        toast.success("Form deleted successfully");
        setFilter((prev) => ({ ...prev, page: 1 }));
      } catch (error) {
        toast.error("Error deleting Form");
      } finally {
        closeModal();
      }
    }
  };

  return (
    <>
      {loading && <Loader />}
      <div className="h-full rounded-md bg-white">
        <div className="flex justify-between p-4">
          <span className="text-2xl font-bold">Forms</span>
          <div className="relative ml-[5rem]">
            {/* <img
              src={searchIcon}
              className="absolute left-3 top-[10px]"
              alt="search-icon"
            ></img> */}
            {/* <input
              onKeyUp={(e) => {
                if (e.key === "Enter") {
                  setFilter((prev) => {
                    let updatedFilter = { ...prev };
                    if (searchField === "") {
                      updatedFilter = { ...updatedFilter, filter: {} };
                      return updatedFilter;
                    }
                    updatedFilter = {
                      ...updatedFilter,
                      filter: {
                        ...updatedFilter.filter,
                        search: searchField,
                      },
                    };
                    return updatedFilter;
                  });
                }
              }}
              onChange={(e) => setSearchField(e.target.value.trim())}
              className=" w-60 rounded bg-[#E5F6FF] py-1 pl-10"
              placeholder="Search"
              type="search"
            /> */}
            <div>
              <Link
                to={`/admin/forms/add`}
                className="flex items-center justify-center gap-2 rounded-sm bg-[#0098DA] px-4 py-2 text-base font-bold text-white"
              >
                <img
                  src={plusIcon}
                  className="my-auto inline"
                  alt="plus-icon"
                ></img>
                Form
              </Link>
            </div>
          </div>
        </div>
        <div>
          {formData && formData.length > 0 ? (
            <DataTable columns={columns} tableData={formData} />
          ) : (
            <div className="flex min-h-[80vh] items-center justify-center text-4xl	font-bold	">
              {!loading ? "No Forms Found" : ""}
            </div>
          )}
        </div>
        <ReactPaginate
          className="pagination"
          previousLabel={"<<"}
          nextLabel={">>"}
          breakLabel={"..."}
          pageCount={Math.ceil(totalCount / filter.limit)}
          marginPagesDisplayed={1}
          pageRangeDisplayed={3}
          onPageChange={onPageChange}
          containerClassName={"pagination"}
          activeClassName={"active"}
          pageClassName={"page"}
          previousClassName={"previous"}
          nextClassName={"next"}
          breakClassName={"break"}
          disabledClassName={"disabled"}
        />
      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Confirm Deletion"
        className="modal"
        overlayClassName="overlay"
      >
        <h2>Are you sure you want to delete this Form?</h2>
        <div className="modal-buttons">
          <button onClick={handleDelete} className="confirm-button">
            Yes
          </button>
          <button onClick={closeModal} className="cancel-button">
            No
          </button>
        </div>
      </Modal>
    </>
  );
};

export default Forms;
